export const TOKEN_KEY = 'token';
export const AUTH_ENTITY_KEY = 'authEntity';
export const AUTH_HOST = 'https://auth.ethervox.io';
export const REDIRECT_URL = '/dashboard-home';
